function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import elementsContext from "./elementsContext";
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
function injectSectionElements(WrappedComponent) {
  function WithElementComponent(props) {
    const value = useContext(elementsContext);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      Elements: value.elements,
      mode: value.mode
    }));
  }
  WithElementComponent.displayName = `WithElements(${getDisplayName(WrappedComponent)})`;
  return WithElementComponent;
}
export default injectSectionElements;
//# sourceMappingURL=injectSectionElements.js.map